import createIcon from '../../createIcon';

/**
 * @component @name AddRoad
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguNSAxNi41VjEzLjVIMTYuNVYxNi41SDEzLjVWMTguNUgxNi41VjIxLjVIMTguNVYxOC41SDIxLjVWMTYuNUgxOC41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE4LjUgMi41SDE2LjVWMTEuNUgxOC41VjIuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik00LjUgMi41SDIuNVYxOC41SDQuNVYyLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTEuNSAyLjVIOS41VjYuNUgxMS41VjIuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMS41IDguNUg5LjVWMTIuNUgxMS41VjguNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMS41IDE0LjVIOS41VjE4LjVIMTEuNVYxNC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AddRoad = createIcon('AddRoad', [
  [
    'path',
    { d: 'M18.5 16.5V13.5H16.5V16.5H13.5V18.5H16.5V21.5H18.5V18.5H21.5V16.5H18.5Z', key: '120o06' },
  ],
  ['path', { d: 'M18.5 2.5H16.5V11.5H18.5V2.5Z', key: 'tlj82c' }],
  ['path', { d: 'M4.5 2.5H2.5V18.5H4.5V2.5Z', key: 'qrz7vs' }],
  ['path', { d: 'M11.5 2.5H9.5V6.5H11.5V2.5Z', key: 'd7kjjw' }],
  ['path', { d: 'M11.5 8.5H9.5V12.5H11.5V8.5Z', key: '152n5h' }],
  ['path', { d: 'M11.5 14.5H9.5V18.5H11.5V14.5Z', key: '5r8jmr' }],
]);

export default AddRoad;
